import { Bullets, Code, HelpSection, Note, P, Screen, SeeAlso, Strong, Terms } from '../prose';

/**
 * 最初に読む記事。
 *
 * 他の記事は全部この前提の上に立っている。ここを飛ばすと、
 * 「なぜタスク単位で記録できないのか」「なぜカテゴリを聞かれないのか」が
 * 個別の不便に見えてしまう。
 */
export function OverviewArticle() {
  return (
    <>
      <HelpSection heading="何を管理するか">
        <P>
          {
            'INOU が持つのは「誰が・どのプロジェクトに・どの月に・何時間」までです。タスク、チケット、スプリントといった細かい単位は扱いません。'
          }
        </P>
        <P>
          {
            '粒度を粗く保っているのは、現場に入力の手間を戻さないためです。予実の管理と会計上の集計はこの粒度で足り、それ以上を求めると記録そのものが続かなくなります。'
          }
        </P>
      </HelpSection>

      <HelpSection heading="どこから記録するか">
        <P>
          {
            '工数の入口は、普段使っている AI クライアント（Claude Code、Cursor など）です。INOU の MCP サーバーに接続しておくと、作業の会話の流れで工数が記録されます。記録のために画面を開く必要はありません。'
          }
        </P>
        <P>
          {'管理画面は、記録された結果を'}
          <Strong>確認する</Strong>
          {'ためと、月を締めるときに'}
          <Strong>訂正する</Strong>
          {'ためにあります。日々の入力を画面で行う想定にはしていません。'}
        </P>
        <Bullets
          items={[
            <>
              {'つなぎ方は '}
              <SeeAlso slug="mcp-setup">MCP をつなぐ</SeeAlso>
              {' にあります。'}
            </>,
            <>
              {'記録のされ方は '}
              <SeeAlso slug="logging-time">工数の記録</SeeAlso>
              {' にあります。'}
            </>,
          ]}
        />
      </HelpSection>

      <HelpSection heading="3 つのロール">
        <P>
          {
            '利用者にはロールが 1 つ付きます。ロールは権限であると同時に、どちらの料金プランのシートを使うかも決めます。'
          }
        </P>
        <Terms
          rows={[
            {
              term: 'mcp',
              value:
                'MCP 接続と、自分の工数・稼働だけ。管理画面のレポートには他のメンバーの数字が出ません。',
            },
            {
              term: 'member',
              value: '管理画面をひととおり見られます。マスタの編集はできません。',
            },
            {
              term: 'admin',
              value:
                'メンバー、プロジェクト、単価、テナント設定まで編集できます。招待もこのロールが行います。',
            },
          ]}
        />
        <P>
          {'詳しくは '}
          <SeeAlso slug="plans-and-seats">プランとシート</SeeAlso>
          {' を参照してください。'}
        </P>
      </HelpSection>

      <HelpSection heading="最初にやること">
        <P>
          {
            '立ち上げの順番は役割によって違います。管理者が先に器を作り、エンジニアは接続だけをします。'
          }
        </P>
        <Terms
          rows={[
            {
              term: '管理者',
              value: (
                <>
                  {'プロジェクト種別・プロジェクト・メンバー・単価・アサインを登録します。順番は '}
                  <SeeAlso slug="admin-setup">初期設定の順番</SeeAlso>
                  {' のとおりです。'}
                </>
              ),
            },
            {
              term: 'エンジニア',
              value: (
                <>
                  <Screen to="/settings/mcp">MCP接続</Screen>
                  {
                    ' でトークンを発行し、AI クライアントに登録します。以降は普段どおり会話するだけです。'
                  }
                </>
              ),
            },
          ]}
        />
        <Note label="はじめる前に">
          <P>
            {
              '管理者の登録が済む前に接続しても、記録先のプロジェクトが 1 件も無いため工数を残せません。'
            }
            <Code>list_projects</Code>
            {' が空で返るときは、まず管理者に登録を依頼してください。'}
          </P>
        </Note>
      </HelpSection>
    </>
  );
}
